import type { ProGender } from '../types/commons';

export const PREVIOUS_PRO_CHOICES = {
  DONT_CARE: 'dont_care',
  ONLY: 'only',
  IF_POSSIBLE: 'if_possible',
  NOT_THIS_TIME: 'not_this_time',
  EXCEPT: 'except',
};

export const PRO_CHOICE_SOURCES = {
  PRO_PROFILE: 'pro_profile',
  PREVIOUS_PRO: 'previous_pro',
};

export const REFERRING_PRO_STATUS = {
  VALID: 'valid',
  TOO_FAR: 'too_far',
  CLOSED: 'closed',
  ON_HOLD: 'on_hold',
};

export const PRO_GENDER_CHOICES: Record<string, ProGender> = {
  DONT_CARE: 'dont_care',
  MAN: 'man',
  WOMAN: 'woman',
};

export const PREVIOUS_PROS_MAX_REVIEWS = 22;
